'use client';

import {
	selectTotalImageUploadCount,
	selectUploadCount,
} from '@/slices/uploadSlice';
import { selectDocMode } from '@/slices/commonSlice';
import { useRouter } from 'next/router';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLottie } from 'lottie-react';
import FormattedMessage from '../FormattedMessage';
import UploadProgressStyle from './UploadProgress.module.scss';
import uploadanimation from './animations/anim_upload_160x160.json';
import documentUploadAnimation from './animations/anim_doc_upload_160x160.json';

// let timer = null;

export default function UploadProgress() {
	const router = useRouter();
	const totalCount = useSelector(selectTotalImageUploadCount);
	const uploadCount = useSelector(selectUploadCount);
	const docMode = useSelector(selectDocMode);

	const uploadTitleId = docMode
		? 'document-upload-progress'
		: 'upload-progress';

	useEffect(() => {
		router.prefetch('/upload-complete');
	}, []);

	useEffect(() => {
		if (uploadCount === totalCount) {
			router.push('/upload-complete');
		}
		// if (timer) {
		// 	clearTimeout(timer);
		// }
		// timer = setTimeout(() => {
		// 	console.log(
		// 		'We have nothing happening for close to 30 seconds so moving forward'
		// 	);
		// 	router.push('/upload-complete');
		// }, 30000);

		// return () => {
		// 	clearTimeout(timer);
		// };
	}, [uploadCount, totalCount]);

	const lottiePrepOptions = {
		animationData: docMode ? documentUploadAnimation : uploadanimation,
		loop: true,
		autoplay: true,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice',
		},
	};

	const { View } = useLottie(lottiePrepOptions);

	const progressBar = useMemo(() => {
		return (
			<div className="progress-bar">
				<div
					className="progress"
					style={
						totalCount
							? {
									width: `${
										((uploadCount < 1 ? 0 : uploadCount) /
											totalCount) *
										100
									}%`,
							  }
							: {}
					}
				/>
			</div>
		);
	}, [uploadCount, totalCount]);

	return (
		<div className={UploadProgressStyle['upload-progress-container']}>
			<div className="animation-outer-wrapper">
				<div className="animation-wrapper">{View}</div>
			</div>
			<div className="upload-progress-title">
				<FormattedMessage id={uploadTitleId} />
			</div>
			<div className="progress-bar-wrapper">{progressBar}</div>
			<div className="upload-progress-counter">
				<FormattedMessage
					id="upload-progress-count"
					dynamic={true}
					values={{ uploadCount, totalCount }}
				/>
			</div>
		</div>
	);
}
